// Handle box info visibility based on payment option selection
(function() {
  const subscriptionOption = document.querySelector('.subscription_option');
  const onetimeOption = document.querySelector('.onetime_option');
  const boxInfoText = document.querySelector('.custom-assortment-info-text');

  if (!subscriptionOption || !onetimeOption || !boxInfoText) return;

  function updateBoxInfoVisibility(isOnetime) {
    boxInfoText.style.display = isOnetime ? 'inline' : 'none';
  }

  subscriptionOption.addEventListener('click', function() {
    updateBoxInfoVisibility(false);
  });

  onetimeOption.addEventListener('click', function() {
    updateBoxInfoVisibility(true);
  });

  subscriptionOption.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') updateBoxInfoVisibility(false);
  });

  onetimeOption.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') updateBoxInfoVisibility(true);
  });
})();